__turbopack_context__.v({
  "product-rating": "product-ratings-component-module-scss-module__7xh3Mq__product-rating",
  "product-rating__stars": "product-ratings-component-module-scss-module__7xh3Mq__product-rating__stars",
});
